<template>
  <div class="row" id="table-bordered">
    <div class="col-12">
      <div class="card col">
        <div class="card-header mb-1">
          <h4 class="card-title">Test natijalari</h4>
          <h4 class="card-title">Umumiy soni <strong>{{ testResultTotals }} </strong>ta</h4>
        </div>
        <div class="card-content">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
              <tr class="text-center">
                <th>FIO</th>
                <th>Telefon</th>
                <th>Test maks. bali</th>
                <th>Test savollari soni</th>
                <th>Foydalanuvchi javoblari soni</th>
                <th>Foydalanuvchi bali</th>
                <th>Test turi</th>
                <th>Test boshlangan vaqti</th>
                <th>Test tugagan vaqti</th>
              </tr>
              </thead>
              <transition name="fade" :duration="2000">
                <tbody v-if="loaded">
                <tr v-for="(spec, index) in specList" :class="spec.id === selectedSpecId ? 'selected_one' : ''" :key="index" class="text-center" @click="selectSpec(spec.id, spec.userFio)">
                  <td style="cursor: pointer">{{ spec.userFio }}</td>
                  <td>{{ spec.userName }}</td>
                  <td>{{ spec.maxBall }}</td>
                  <td>{{ spec.quesCount }}</td>
                  <td>{{ spec.userAnsCount }}</td>
                  <td>{{ spec.userTestBall }}</td>
                  <td>{{ spec.testType }}</td>
                  <td>{{ spec.beginTime ? $moment(spec.beginTime).format('YYYY-DD-MM HH:ss') : '' }}</td>
                  <td>{{ spec.endTime ? $moment(spec.endTime).format('YYYY-DD-MM HH:ss') : '' }}</td>
                </tr>
                </tbody>
              </transition>
            </table>
          </div>

          <div class="d-flex justify-content-center mt-1" v-if="specList && totalSize > 10">
            <v-pagination
              v-model="currentPage"
              :classes="bootstrapPaginationClasses"
              :page-count="totalSize"
            />
          </div>
        </div>
      </div>
      <div class="card col-12">
        <div class="card-header mb-1">
          <h4 class="card-title">Test topshirilgan fanlar</h4>
          <h4 class="card-title">Foydalanuvchi: <strong>{{ selectedSpecName }}</strong></h4>
        </div>
        <div class="card-content">
          <div class="table-responsive">
            <table class="table table-bordered mb-0">
              <thead>
              <tr class="text-center">
                <th>#</th>
                <th>Fan</th>
                <th>Maksimum ball</th>
                <th class="text-center">Savollar soni</th>
                <th class="text-center">Foydalanuvchi javoblari soni</th>
                <th class="text-center">Foydalanuvchi to'plagan ball</th>
                <th/>
              </tr>
              </thead>
              <transition name="fade" :duration="2000">
                <tbody v-if="loaded">
                <tr v-for="(subject, index) in abitExamList" class="text-center">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ subject.subjectName }}</td>
                  <td>{{ subject.maxBall }}</td>
                  <td class="text-center">{{ subject.quesCount }}</td>
                  <td class="text-center">{{ subject.userAnsCount }}</td>
                  <td class="text-center">{{ subject.userTestBall }}</td>
                </tr>
                </tbody>
              </transition>
            </table>
          </div>

          <div class="d-flex justify-content-center mt-1" v-if="specList && specList.length > 10">
            <v-pagination
              v-model="currentPage"
              :classes="bootstrapPaginationClasses"
              :page-count="totalSize"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'

export default {
  name: "Subjects",
  components: {
    vPagination
  },
  data() {
    return {
      testResultTotals: null,
      specList: [],
      subject: {},
      exam: {},
      loaded: false,
      showModal: false,
      showExamModal: false,
      something: false,
      deleteApi: '',
      totalSize: 1,
      currentPage: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      abitExamList: [],
      subjectList: [],
      subjectStatusList: [],
      subjectStatuses: [],
      selectedSpecName: '',
      selectedSpecId: null,
    }
  },

  methods: {
    selectSpec(specId, specName) {
      this.abitExamList = [];
      this.selectedSpecName = specName;
      this.selectedSpecId = specId;
      let exam = this.specList.find(s => parseInt(s.id) === parseInt(specId));
      if (exam) {
        this.abitExamList = exam.subjectList;
      }
    },
    getSpecs(skip = 0) {
      this.loaded = false;
      this.$api.get(`admin/Monitoring/TestResult?skip=${skip}&take=5`).then(res => {
        if (!res.error) {
          this.specList = res.result.data;
          this.totalSize = Math.ceil(res.result.total / 5);
          this.testResultTotals = res.result.total;
          this.selectedSpecName = this.selectedSpecName ? this.selectedSpecName : this.specList[0].userFio;
          this.selectedSpecId = this.selectedSpecId ? this.selectedSpecId : this.specList[0].id
          this.abitExamList = [];
          let exam = this.specList.find(s => parseInt(s.id) === parseInt(this.selectedSpecId));
          if (exam) {
            this.abitExamList = exam.subjectList;
          }
        }
      })
        .catch(err => {
          //
        })
        .finally(() => {
          this.loaded = true
        })
    },
  },
  watch: {
    currentPage() {
      this.getSpecs(this.currentPage - 1);
    }
  },
  created() {
    this.getSpecs();
  }
}
</script>

<style scoped>
.selected_one {
  color: white;
  background-color: #7367F0;
}

.table-hover tbody tr:hover {
  color: white;
  background-color: #7367F0;
}
</style>
